import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import Home from "./components/pages/Home";
import Login from "./components/pages/Login";
import Produtos from "./components/pages/Produtos";
 import ScrollToTop from "./components/ScrollToTop";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


 

 
 const App = () => {
  const [isDarkMode, setIsDarkMode] = useState(true);

  return (
    <>
      <Router>
        <ScrollToTop />

        <Routes>
          <Route path="/" element={<Home isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>} />
           <Route path="/login" element={<Login />} />
           <Route path="/produtos" element={<Produtos />} />
           
        </Routes>
      </Router>

      {/* 🔥 ToastContainer GLOBAL */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        toastStyle={{ borderRadius: 12 }}
      />
    </>
  );
};


export default App;

